import { ButtonIcon, InfoAlert } from '@arvoreeducacao/bonsai-ds'
import type { LanguageTokens } from 'i18n'
import { useTranslation } from 'i18n'
import React from 'react'
import {
  EditModeWrapper,
  EditModeTitle,
  EditModeSelectedEntity,
  EditModeSelectedEntityLabel,
  EditModeSelectedEntityInputFake,
  EditModeGoal,
  EditModeGoalLabel,
  EditModeGoalInputFake
} from '../NewReadingGoalModal.styles'
import type { NewReadingGoalModalProps } from '../NewReadingGoalModal.types'

const EditionSummary = ({
  entityGoalEditing,
  handleClickEditGoal
}: {
  entityGoalEditing: NewReadingGoalModalProps['entityGoalEditing']
  handleClickEditGoal: () => void
}) => {
  const { t } = useTranslation()

  return (
    <EditModeWrapper>
      <EditModeTitle size={3}>{t('Edite as metas de leitura')}</EditModeTitle>
      <EditModeSelectedEntity>
        <EditModeSelectedEntityLabel>
          {t('Turma selecionada')}
        </EditModeSelectedEntityLabel>
        <EditModeSelectedEntityInputFake>
          {entityGoalEditing.entityName}
        </EditModeSelectedEntityInputFake>
      </EditModeSelectedEntity>
      <EditModeGoal>
        <EditModeGoalLabel>{t('Meta semanal aplicada')}</EditModeGoalLabel>
        <EditModeGoalInputFake>
          <div>
            {entityGoalEditing.goal}
            {t('min' as LanguageTokens)}
          </div>
          <ButtonIcon
            iconName="pencil"
            onClick={handleClickEditGoal}
            theme={{ type: 'ghost', size: 'large' }}
          />
        </EditModeGoalInputFake>
      </EditModeGoal>
      <InfoAlert
        hasMarketList
        boldTitle
        title={t('Atenção ao editar')}
        description={t(
          'Editar a meta substituirá as informações anteriores e as mudanças não poderão ser desfeitas.'
        )}
        icon="warning"
        variant="warning"
      />
    </EditModeWrapper>
  )
}

export default EditionSummary
